module.exports = __webpack_public_path__ + "static/img/y6.c2bb72ef.svg";